import { useContext } from "react";
import LabFormContext from "../context/LabFormProvider";

const useLabForm =()=>{
    return useContext(LabFormContext)
}
export default useLabForm